// @flow
import React, { useState, useEffect } from 'react';
import ReactSlider from 'react-slider';
import './Split.scss';

import { dispatch } from '../../redux';

import { actions } from 'react-redux-form';

const convertFromSplitsToValues = (splits) => {
  const values = [];
  let runningTotal = 0;
  for (let i = 0; i < splits.length - 1; i++) {
    runningTotal += splits[i].value;
    values.push(runningTotal);
  }
  return values;
};

const convertValuesBackToSplits = (inputValues, splits) => {
  const values = [].concat(inputValues);
  return splits.map((split, index) => {
    const currentValue = values[index] === undefined ? 100 : values[index];
    const previousValue = values[index - 1] === undefined ? 0 : values[index - 1];
    split.value = currentValue - previousValue;
    return split;
  }).reduce((acc, split) => {
    acc[split.key] = split.value;
    return acc;
  }, {});
};

const SplitSlider = ({ splits, onChange }) => (
  <ReactSlider
    withBars
    value={convertFromSplitsToValues(splits)}
    pearling
    onChange={onChange}
  />
);

const SplitTable = ({ splits, splitValues, onSplitChange, onSplitBlur, onSplitKeyPress }) => (
  <table className="splitTable">
    <thead>
      <tr>
        <th>Key</th>
        <th>Split</th>
        <th>Color</th>
      </tr>
    </thead>
    <tbody>
      {splits.map((split, index) => (
        <tr key={split.key}>
          <td>{split.key}</td>
          <td style={{ width: 50 }} className="percentInput">
            <input
              value={splitValues[split.key]}
              onBlur={(event) => onSplitBlur(event.target.value, split.key)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  onSplitKeyPress(splitValues[split.key], split.key);
                }
              }}
              onChange={(event) => {
                const value = Number.parseInt(event.target.value, 10);
                const boundedValue = Math.min(Math.max(value, 0), 100);
                onSplitChange(split.key, Number.isNaN(value) ? '' : boundedValue);
              }}
            />
          </td>
          <td style={{ width: 50 }} className={`track-${index}`} />
        </tr>
      ))}
    </tbody>
  </table>
);

const Split = ({ variants, splitValues, baseRuleModel }) => {
  const [localSplitValues, setLocalSplitValues] = useState(splitValues);

  useEffect(() => {
    setLocalSplitValues(splitValues);
  }, [splitValues]);

  const handleSplitChange = (key, value) => {
    setLocalSplitValues(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const updateSplitValues = (inputValue, key) => {
    const value = Number.parseInt(inputValue || 0, 10);
    const originalBucketSize = 100 - splitValues[key];
    const newBucketSize = 100 - value;

    let variantsToUpdate = variants.filter(variant => variant.key !== key);
    
    if (variantsToUpdate.reduce((prev, next) => prev + splitValues[next.key], 0) + value === 0) {
      const defaultSplits = Object.keys(splitValues).map(key => ({
        key,
        value: Math.floor(100 / Object.keys(splitValues).length)
      }));

      let defaultToFill = newBucketSize - defaultSplits.reduce((prev, next) => prev + next.value, 0);
      for (defaultToFill; defaultToFill > 0; defaultToFill--) {
        defaultSplits[defaultToFill % defaultSplits.length].value++;
      }

      return dispatch(actions.change(
        `form.rules.${baseRuleModel}.splits`,
        defaultSplits.reduce((acc, next) => {
          acc[next.key] = next.value;
          return acc;
        }, {})
      ));
    }

    variantsToUpdate = variantsToUpdate.map(variant => ({
      key: variant.key,
      value: Math.floor(splitValues[variant.key] / originalBucketSize * newBucketSize)
    }));

    let toFill = newBucketSize - variantsToUpdate.reduce((prev, next) => prev + next.value, 0);
    for (toFill; toFill > 0; toFill--) {
      variantsToUpdate[toFill % variantsToUpdate.length].value++;
    }

    const newSplits = {
      ...variantsToUpdate.reduce((acc, next) => {
        acc[next.key] = next.value;
        return acc;
      }, {}),
      [key]: value
    };

    return dispatch(actions.change(`form.rules.${baseRuleModel}.splits`, newSplits));
  };

  const splits = variants.map(variant => ({
    key: variant.key,
    value: splitValues[variant.key] || 0
  }));

  return (
    <div>
      <SplitSlider
        splits={splits}
        onChange={(values) => {
          dispatch(actions.change(
            `form.rules.${baseRuleModel}.splits`,
            convertValuesBackToSplits(values, splits)
          ));
        }}
      />
      <SplitTable
        splits={splits}
        splitValues={localSplitValues}
        onSplitChange={handleSplitChange}
        onSplitBlur={updateSplitValues}
        onSplitKeyPress={updateSplitValues}
      />
    </div>
  );
};

export default Split;